import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-af5cd2f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share-button" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "row",
  style: {"margin-top":"15px","padding-top":"15px","border-top":"1px solid #e6e6e6"}
}
const _hoisted_8 = { class: "col-sm-9" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-right",
  style: {"padding-top":"7px"}
}, " Anyone with this link can view the report: ", -1))
const _hoisted_10 = { class: "invite-link-wrapper form-control form-control-lg hidden" }
const _hoisted_11 = ["disabled", "value"]
const _hoisted_12 = { class: "col-sm-3 text-right" }

import { computed, ref, onMounted } from "vue";
import axios from "axios";
import { Modal } from "uiv";
import { Analytics } from "../services/analytics/analytics";
import {
  ReportSharingSettingsApiModel,
  ReportSharingSettingsUpdateApiModel,
  ReportSharingTypeApiModel,
} from "../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'share-button',
  props: {
    reportType: {},
    reportEntityId: {},
    urlDescription: {}
  },
  setup(__props: any) {

const props = __props;

const isLoaded = ref(false);
const show = ref(false);
const m_isSharingEnabled = ref(false);
const copied = ref(false);
const code = ref("");

const isSharingEnabled = computed({
  get() {
    return m_isSharingEnabled.value;
  },
  set(value: boolean) {
    m_isSharingEnabled.value = value;
    axios.patch("/api/reportsharing", {
      reportType: props.reportType,
      reportEntityId: props.reportEntityId,
      isLinkSharingEnabled: m_isSharingEnabled.value,
    } as ReportSharingSettingsUpdateApiModel);
  },
});

const title = computed(() => `Share '${document.title.replace(" - Gyre", "")}'`);

const close = () => {
  show.value = false;
};

const transformedUrlDescription = computed(() =>
  props.urlDescription
    .toLowerCase()
    .replace(/[^\w ]/gi, "")
    .replace(/[ ]/g, "-"),
);

const inviteUrl = computed(
  () =>
    new URL(`/sharedreport/${code.value}/${transformedUrlDescription.value}`, window.location.href)
      .href,
);

onMounted(() => {
  axios
    .get("/api/reportsharing", {
      params: {
        reportType: props.reportType,
        reportEntityId: props.reportEntityId,
      },
      validateStatus(status) {
        return status >= 200 && status < 300;
      },
    })
    .then((res) => {
      if (res.status === 403 || !res.data) {
        isLoaded.value = false;
        return;
      }
      const model = res.data as ReportSharingSettingsApiModel;
      m_isSharingEnabled.value = model.linkSharing?.isEnabled;
      code.value = model.linkSharing.code;
      isLoaded.value = true;
    })
    .catch(() => {
      isLoaded.value = false; // May not be authorised to change sharing settings
    });
});

function copyUrlToClipboard(): void {
  const tempInput = document.createElement("input");
  tempInput.value = inviteUrl.value;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  copied.value = true;
  Analytics.action("Copied Report Share Link", "CopiedReportShareLink", {
    reportType: props.reportType,
    reportEntityId: props.reportEntityId,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true)),
            class: "btn btn-primary-share",
            "data-test": "sharing-button"
          }, "Share"),
          _createVNode(_unref(Modal), {
            modelValue: show.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((show).value = $event)),
            header: false,
            footer: false,
            style: {"font-size":"18px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", null, [
                    _createTextVNode(" Allow link sharing?   "),
                    _withDirectives(_createElementVNode("input", {
                      name: "allow-sharing",
                      type: "checkbox",
                      class: "toggle-switch-checkbox",
                      style: {"vertical-align":"bottom","margin-left":"10px"},
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isSharingEnabled).value = $event)),
                      "data-test": "enable-link-sharing-checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, isSharingEnabled.value]
                    ])
                  ]),
                  _createElementVNode("div", { style: {"float":"right"} }, [
                    _createElementVNode("button", {
                      onClick: close,
                      type: "button",
                      "aria-label": "Close",
                      class: "close",
                      style: {"position":"relative","z-index":"1060","font-size":"28px","line-height":"1.4"}
                    }, _hoisted_6)
                  ])
                ])
              ]),
              (isSharingEnabled.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("input", {
                          ref: "inviteLink",
                          type: "text",
                          disabled: !isSharingEnabled.value,
                          class: "invite-link-input hidden",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCodeUrl())),
                          value: inviteUrl.value,
                          readonly: "",
                          "data-test": "link-sharing-url-textbox",
                          "aria-label": "Link to share report"
                        }, null, 8, _hoisted_11)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("a", {
                        role: "button",
                        href: "javascript:void(0)",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (copyUrlToClipboard())),
                        class: _normalizeClass(["btn btn-lg btn-link", {
                'btn-default-share': !copied.value,
                'btn-default-tick': copied.value,
              }]),
                        style: {"margin-left":"-15px"}
                      }, _toDisplayString(copied.value ? "Copied!" : "Copy link"), 3)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})